export default __webpack_public_path__ + "static/Martinez-53b42525c44e410a2a27181c661fe4fa.jpg";